import { render, staticRenderFns } from "./TicketTypeDetail.vue?vue&type=template&id=7a16b90a&"
import script from "./TicketTypeDetail.vue?vue&type=script&lang=js&"
export * from "./TicketTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports